'use client';

const defaultCounterLabel = (count) => count > 1 ? "items" : "item";
export {
  defaultCounterLabel
};
